import DefaultContaCorrenteProps from 'components/resources/condominios/ModalEditaContaBancaria/bancos/default/ContaCorrenteProps';
import validateSeEmitindoBoletosEDependendoDoTipoIntegracaoId from './validateSeEmitindoBoletosEDependendoDoTipoIntegracaoId';

const validacoes = [...DefaultContaCorrenteProps.validacoes, validateSeEmitindoBoletosEDependendoDoTipoIntegracaoId];

export default validacoes;
